module.exports = __webpack_public_path__ + "img/image_1.2f7c6cb1.png";